export const formatPriceStorage = (
    storage,
    rate,
    isPercent = false,
    values = null,
    remainAmount
) => {
    if (!storage?.pricePerMetrSquare && !rate) return null;

    const basePrice =
        storage.pricePerMetrSquare * rate*storage.m2 ;

    let finalPrice = basePrice;
    // Agar perMonth yuborilgan bo'lsa
    if (values?.isInstallmentPayment) {
        if (isPercent) {
            finalPrice = (basePrice * values?.downPaymentPercent) / 100; // foiz
        }else if (remainAmount) {
            finalPrice = ((basePrice * (100-values?.downPaymentPercent)) / 100) // oyga bo‘lish

        }
        else {
            finalPrice = ((basePrice *  (100-values?.downPaymentPercent)) / 100) / values?.paymentDurationPerMonth; // oyga bo‘lish
        }
    }

    // 1 xonali aniqlik
    finalPrice = Math.round(finalPrice * 10) / 10;

    // 1 234 567 format
    return finalPrice
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
